module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Modal', {
    attrs: {
      "title": ("订单权益 (订单课时：" + _vm.totalNum + ")"),
      "width": "815"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Table', {
    staticClass: "compact",
    attrs: {
      "size": "small",
      "columns": _vm.column,
      "data": _vm.dataList
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7479466a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/OrderClassHourModal.vue
// module id = 1868
// module chunks = 8